import React from 'react';
import PropTypes from 'prop-types';
import { FixedSizeList as List } from 'react-window';

const ITEM_SIZE = 50;
const MAX_HEIGHT = 270;

const MenuList = ({ options, children, getValue }) => {
  const [value] = getValue();
  const selectedIndex = options.indexOf(value);
  const initialScrollOffset = selectedIndex > 0 ? selectedIndex * ITEM_SIZE : 0;
  const height = Math.min(MAX_HEIGHT, children.length * ITEM_SIZE);

  return (
    <List
      height={height}
      itemCount={children.length}
      itemSize={ITEM_SIZE}
      initialScrollOffset={initialScrollOffset}
    >
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </List>
  );
};

MenuList.propTypes = {
  options: PropTypes.array,
  children: PropTypes.array,
  getValue: PropTypes.func,
};

export default MenuList;
